import { Skeleton } from '@/components/ui/skeleton'

/** Esqueleto del primer vistazo: encabezado y fila de 4 KPIs con su forma final. */
export function DashboardSkeleton() {
  return (
    <div className="space-y-4" aria-busy="true" aria-label="Cargando dashboard">
      <div className="flex items-center gap-3 rounded-xl border border-slate-100 bg-white p-4 shadow-sm">
        <Skeleton variant="circular" width={48} height={48} />
        <div className="flex-1 space-y-2">
          <Skeleton height={12} width={96} />
          <Skeleton height={24} width={160} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="space-y-3 rounded-xl border border-slate-100 bg-white p-4 shadow-sm">
            <Skeleton height={32} width={32} />
            <Skeleton height={12} width={80} />
            <Skeleton height={28} width="50%" />
          </div>
        ))}
      </div>
    </div>
  )
}
